import { useEffect } from 'react';

import { OrderExecutionTermsOperationKind } from 'api/types/entity/account/order';

import { useField } from '../../../forms/orderForm';

export const useConfirmationDocumentSection = () => {
  const { field: operationKindField } = useField(
    'executionTerms.operationKind'
  );

  const { helpers: dateFieldHelpers } = useField(
    'confirmationDocument.contractDate'
  );

  const { helpers: numberFieldHelpers } = useField(
    'confirmationDocument.contractNumber'
  );

  const { field: filesField } = useField('confirmationDocument.files');

  const isDisabledField =
    !operationKindField?.value?.value ||
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.ChangeNominalHolder;

  const isRequiredField =
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.DeliveryFreeOfPayment ||
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.DeliveryVersusPayment;

  useEffect(() => {
    if (isDisabledField) {
      dateFieldHelpers.setValue(null);
      dateFieldHelpers.setError(undefined);
      numberFieldHelpers.setError(undefined);
      numberFieldHelpers.setValue(undefined);
    }
  }, [isDisabledField, dateFieldHelpers, numberFieldHelpers]);
  return {
    files: filesField.value,
    isRequiredField,
    isDisabledField,
  };
};
